import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Opens to the content's natural height and closes to nothing, without measuring it. */
export const Reveal = ({ open, className, children }: { open: boolean; className?: string; children: ReactNode }) => (
  <div
    className={cn(
      'grid transition-[grid-template-rows] duration-300 ease-out',
      open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
      className
    )}
  >
    {/* Folded content stays mounted for the animation, but nothing in it can be reached. */}
    <div className='overflow-hidden' inert={!open}>
      {children}
    </div>
  </div>
);
